import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const services = [
  {
    icon: 'ri-box-3-line',
    title: 'Conception 3D',
    description: 'Visualisez votre espace avant les travaux grâce à des rendus 3D photoréalistes de haute qualité.',
    color: 'fuchsia',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: "Conseil en Aménagement",
    description: "Bénéficiez de l'expertise de nos designers pour optimiser chaque centimètre de votre espace.",
    color: 'coral',
  },
  {
    icon: 'ri-sofa-line',
    title: 'Mobilier sur Mesure',
    description: "Créez des meubles uniques fabriqués sur mesure qui s'adaptent parfaitement à votre intérieur.",
    color: 'gold',
  },
  {
    icon: 'ri-eye-line',
    title: 'Suivi de Projet',
    description: "De la conception à la réalisation, nous assurons un suivi complet pour garantir un résultat parfait.",
    color: 'sage',
  },
];

const colorMap: Record<string, { bg: string; text: string }> = {
  fuchsia: { bg: 'bg-brand-fuchsia', text: 'text-white' },
  coral: { bg: 'bg-brand-coral', text: 'text-white' },
  gold: { bg: 'bg-brand-gold', text: 'text-white' },
  sage: { bg: 'bg-brand-sage', text: 'text-white' },
};

const InterieurServicesGrid = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Notre Expertise</span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">Nos Services Intérieur</h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Nous transformons vos espaces de vie et de travail en environnements élégants, fonctionnels et à votre image.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, idx) => (
            <div
              key={service.title}
              className={`group bg-brand-beige rounded-2xl p-7 text-center hover:-translate-y-2 transition-all duration-500 cursor-default ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${idx * 120}ms`, transitionDuration: '600ms' }}
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-5 ${colorMap[service.color].bg} group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-2xl ${colorMap[service.color].text}`} />
              </div>
              <h3 className="font-serif text-lg font-semibold text-brand-anthracite mb-3">{service.title}</h3>
              <div className="h-px w-8 bg-brand-gold/50 mx-auto mb-3" />
              <p className="text-sm text-brand-gray leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterieurServicesGrid;
